import React from "react"
import { Link } from "gatsby"
import { useIntl, FormattedMessage } from "gatsby-plugin-intl"

const BannerHeader = ({ background, title, servicesDetails }) => {
  const intl = useIntl()
  const locale = intl.locale !== "en" ? `/${intl.locale}` : ""
  return (
    <div className="page-content">
      <div
        className="dlab-bnr-inr overlay-black-light bg-pt bannerHeader"
        style={{ backgroundImage: "url(" + background + ")", height: "250px" }}
      >
        <div className="container">
          <div className="dlab-bnr-inr-entry" style={{ height: "250px" }}>
            <h1 className="text-white">{title}</h1>
            <div className="breadcrumb-row">
              <ul className="list-inline">
                <li>
                  <Link to={`${locale}/`}>
                    {intl.formatMessage({
                      id: "productsandservices.banner.smalltitle.1",
                    })}
                  </Link>
                </li>
                {servicesDetails && (
                  <>
                    <li>
                      {intl.formatMessage({
                        id: "header.productsandservices",
                      })}
                    </li>
                    <li>
                      {intl.formatMessage({
                        id: "productsandservices.banner.smalltitle.2",
                      })}
                    </li>
                  </>
                )}
                <li>{title}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BannerHeader
